"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var R = _interopRequireWildcard(require("ramda"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _utils = require("@trs/utils");
var _Section = _interopRequireDefault(require("../Section/Section"));
var _ContributionBlock = _interopRequireDefault(require("./ContributionBlock"));
var _Threshold = _interopRequireDefault(require("./Threshold.style"));
var _ThresholdMember = _interopRequireDefault(require("./ThresholdMember"));
var _card = require("../../card");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var Thresholds = function Thresholds(_ref) {
  var ruleIndex = _ref.ruleIndex,
    labels = _ref.labels,
    builderData = _ref.builderData,
    thresholds = _ref.thresholds,
    errors = _ref.errors,
    formulaOperators = _ref.formulaOperators,
    actions = _ref.actions,
    disabled = _ref.disabled;
  if (R.isEmpty(builderData) && R.isEmpty(thresholds)) {
    return /*#__PURE__*/_react["default"].createElement(_Section["default"], {
      name: "".concat((0, _utils.toUpper)(labels.PENSION_THRESHOLD_LABEL), " 1"),
      index: 1,
      labels: labels,
      className: "formula-empty-placeholder"
    }, /*#__PURE__*/_react["default"].createElement(_card.BuildArea, {
      className: "formula-placeholder"
    }, labels.PENSION_THRESHOLD_PLACEHOLDER));
  }
  return thresholds.map(function (item, index) {
    var thresholdActions = {
      onAdd: function onAdd() {
        return actions.thresholdChange('add', {
          ruleIndex: ruleIndex,
          thresholdIndex: index
        });
      },
      onDuplicate: function onDuplicate() {
        return actions.thresholdChange('duplicate', {
          ruleIndex: ruleIndex,
          thresholdIndex: index,
          sourceThreshold: item
        });
      }
    };
    if (thresholds.length > 1) {
      thresholdActions.onDelete = function () {
        return actions.thresholdChange('delete', {
          ruleIndex: ruleIndex,
          thresholdIndex: index
        });
      };
    }
    return /*#__PURE__*/_react["default"].createElement(_Section["default"], _extends({
      disabled: disabled,
      name: "".concat((0, _utils.toUpper)(labels.PENSION_THRESHOLD_LABEL), " ").concat(index + 1),
      key: item.name,
      index: index + 1
    }, thresholdActions, {
      labels: labels,
      className: R.isEmpty(builderData) ? 'formula-empty-placeholder' : ''
    }), R.isEmpty(builderData) ? /*#__PURE__*/_react["default"].createElement(_card.BuildArea, {
      className: "formula-placeholder"
    }, labels.PENSION_THRESHOLD_PLACEHOLDER) : /*#__PURE__*/_react["default"].createElement(_Threshold["default"], null, R.prop('thresholdRows', item) && item.thresholdRows.map(function (thresholdRowData, thresholdRowIndex) {
      return /*#__PURE__*/_react["default"].createElement(_ThresholdMember["default"], {
        actions: actions,
        ruleIndex: ruleIndex,
        disabled: disabled,
        elementKey: thresholdRowData.key,
        key: thresholdRowData.field,
        errors: R.prop(index, errors),
        thresholdIndex: index,
        blockType: thresholdRowIndex === 0 ? 'if' : 'and',
        thresholdRowIndex: thresholdRowIndex,
        labels: labels,
        thresholds: item,
        blockData: R.path(['thresholdRows', thresholdRowIndex], item),
        formulaOperators: formulaOperators
      });
    }), /*#__PURE__*/_react["default"].createElement(_ContributionBlock["default"], {
      data: item,
      labels: labels,
      errors: errors,
      disabled: disabled,
      ruleIndex: ruleIndex,
      formulaOperators: formulaOperators,
      thresholdIndex: index,
      member: item,
      key: item.key,
      keysPath: [index],
      actions: actions
    })));
  });
};
Thresholds.defaultProps = {
  errors: {},
  disabled: false
};
Thresholds.propTypes = {
  disabled: _propTypes["default"].bool,
  ruleIndex: _propTypes["default"].number.isRequired,
  errors: _propTypes["default"].shape({}),
  formulaOperators: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    displayName: _propTypes["default"].string,
    name: _propTypes["default"].string
  })).isRequired,
  labels: _propTypes["default"].objectOf(_propTypes["default"].string).isRequired,
  builderData: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    value: _propTypes["default"].string,
    type: _propTypes["default"].string,
    displayName: _propTypes["default"].string
  })).isRequired,
  actions: _propTypes["default"].objectOf(_propTypes["default"].func).isRequired,
  formulaOtherProps: _propTypes["default"].shape({}),
  /* The root thresholds for each threshold */
  thresholds: _propTypes["default"].arrayOf(_propTypes["default"].shape({})).isRequired
};
var _default = exports["default"] = Thresholds;